import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  useEffect(() => {
    // Create the Sayify widget script
    const script = document.createElement('script');
    script.src = "https://resource.sayify.pro/cdn/widget.js";
    script.async = true;
    
    // Set Sayify configuration attributes
    script.setAttribute('data-slug', 'customer-inquiry');
    script.setAttribute('data-mode', 'inline-form');
    script.setAttribute('data-base-url', 'https://crcnu.sayify.pro');
    script.setAttribute('data-label', 'Feedback');
    script.setAttribute('data-color', '#C86A4A');
    script.setAttribute('data-position', 'bottom-right');
    script.setAttribute('data-description', 'Share your feedback by voice');
    script.setAttribute('data-inline-height', '600');
    script.setAttribute('data-auto-height', 'true');
    script.setAttribute('data-container', 'sayify-widget-container');
    
    // Append the script to the document body
    document.body.appendChild(script);
    
    // Clean up on component unmount
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Schedule Your Free Internet Consultation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Take the first step toward better business internet. Our experts will analyze your needs 
            and find the perfect solution for your Hudson Valley business.
          </p>
        </motion.div>

        <div className="flex justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="w-[80%] bg-white rounded-2xl shadow-xl p-8"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Get started today</h3>
            
            <div className="w-full">
              {/* Sayify Widget Container */}
              <div id="sayify-widget-container" className="min-h-[600px] w-full"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;